// extracted by mini-css-extract-plugin
export default {"payments":"payments_payments__VXEun","cardTemplateWrapper":"payments_cardTemplateWrapper__cAXlx"};